/* eslint-disable */
export default {
  data: () => ({
    isResponsible: false
  }),
  methods: {
    recursiveDeleteSubTask (item, task, treeSequence, i = 0) {
      if (item.task_id === treeSequence[i]) {
        if (task.all_subtasks.length === task.subtasks_clean_count) {
          const itemIndex = task.all_subtasks.findIndex((element) => {
            return element.id === item.id
          })
          task.all_subtasks.splice(itemIndex, 1)
        }
        this.changeSubtasksCount(item, 'del')
        this.reloadFilter()
      } else {
        let nextTask = task.all_subtasks.find((val) => {
          return val.id === treeSequence[i + 1]
        })
        if (nextTask) {
          this.recursiveDeleteSubTask(item, nextTask, treeSequence, i + 1)
        }
      }
    },
    recursiveEditSubTasktemplate (item, task, treeSequence, i = 0) {
      if (item.tasktemplate_id === treeSequence[i]) {
        let findItem = task.all_subtasks.find((element) => {
          return element.id === item.id
        })
        if (findItem) {
          Object.assign(findItem, item)
          let items = this.items.find(
            (element) => { return element.id === item.top_id })
          let allItem = this.allItems.find(
            (element) => { return element.id === item.top_id })
          if (items) {
            Object.assign(items, JSON.parse(JSON.stringify(allItem)))
          }
        }
      } else {
        let nextTask = task.all_subtasks.find((val) => {
          return val.id === treeSequence[i + 1]
        })
        if (nextTask) {
          this.recursiveEditSubTasktemplate(item, nextTask, treeSequence, i + 1)
        }
      }
    },
    methodGeneralSocket (item) { },
    beforeAddSocketItem (item) { },
    afterAddSocketItem (item) { },
    beforeDeleteSocketItem (item) { },
    afterDeleteSocketItem (item) { },
    beforeEditSocketItem (item) { },
    afterEditSocketItem (item) { },
    beforeAddSocketDetails (item) { },
    afterAddSocketDetails (item) { },
    beforeDeleteSocketDetails (item) { },
    afterDeleteSocketDetails (item) { },
    beforeEditSocketDetails (item) { },
    afterEditSocketDetails (item) { },
    beforeAddSocketItemDetails (item) { },
    beforeEditSocketItemDetails (item) { },
    beforeDeleteSocketItemDetails (item) { },
    beforeReloadPageModules (item) { },
    afterEditSocketManagementDetails (item) { },
    beforeSocketSnackbar (item) { },
    afterSocketSnackbar (item) { }
  },
  sockets: {
    addSubTasktemplate (item) {
      // Tenta encontrar a tarefa pai.
      let topTask = this.allItems.find((val) => {
        return val.id === item.top_id
      })
      if (topTask) {
        this.changeSubtaskstemplateCount(item, 'add', true)
      }
    },
    deleteSubTask (item) {
      // Encontra a topTask na lista de tarefas do usuário
      let topTask = this.allItems.find((val) => {
        return val.id === item.top_id
      })
      if (topTask) {
        this.changeSubtaskstemplateCount(item, 'del', true)
      }
    },
    editSubTask (item) {
      // Encontra a top task
      let topTask = this.allItems.find((val) => {
        return val.id === item.top_id
      })
      if (topTask) {
        let treeSequence = this.changeOrderSequence(
          item.tree_tasktemplate_sequence)
        this.recursiveEditSubTasktemplate(item, topTask, treeSequence)
      }
    },
    // EVENTOS PARA MANIPULAÇÃO DOS ITEMS
    // Evento 'addSocketItem' emitido pelo servidor quando o usuário adiciona um item.
    addSocketItem (item) {
      let socketItem = ''
      if (item.details) {
        socketItem = item.values
      } else {
        socketItem = item
      }
      if (this.beforeAddSocketItem(socketItem) !== false) {
        this.items.push(JSON.parse(JSON.stringify(socketItem)))
        this.allItems.push(JSON.parse(JSON.stringify(socketItem)))
        this.redoFilter()
        this.afterAddSocketItem(socketItem)
      }
    },
    // Evento "editSocketItem" emitido pelo servidor quando o usuário edita algum item.
    editSocketItem (item) {
      let socketItem
      if (item.details) {
        socketItem = item.values
      } else {
        socketItem = item
      }
      if (this.beforeEditSocketItem(socketItem) !== false) {
        Object.assign(this.items.find(
          (val) => { return val.id === socketItem.id }) || {},
          JSON.parse(JSON.stringify(socketItem)))
        Object.assign(this.allItems.find(
          (val) => { return val.id === socketItem.id }) || {},
          JSON.parse(JSON.stringify(socketItem)))
        this.redoFilter()
      }
    },
    // Evento "deleteSocketItem" emitido pelo servidor quando algum item é deletado.
    deleteSocketItem (item) {
      if (this.beforeDeleteSocketItem(item) !== false) {
        const itemIndex = this.items.findIndex(
          (element) => { return element.id === item.id })
        const allItemIndex = this.allItems.findIndex(
          (element) => { return element.id === item.id })
        this.items.splice(itemIndex, 1)
        this.allItems.splice(allItemIndex, 1)
        this.redoFilter()
      }
    },
    // ==========================================================================================
    // EVENTO PARA ADIÇÃO DE MULTIPLOS DETALHES
    // Evento emitido quando o usuário adiciona mais de um detalhe a algum item. Neste caso, o evento recebe um array de objetos como parametro, por isso faz o loop para adicionar.
    // É usado, por exemplo, na tela de parcerias ao adicionar usuários a uma conexão.
    addSocketManyDetails (item) {
      item.values.forEach((value) => {
        // verifica se o item a ser inserido já não existe na lista
        if (!this.editedItem[item.details].some((val) => {
          return val.id === value.id
        })) {
          this.editedItem[item.details].push(value)
          this.editedItemDB[item.details].push(value)
        }
      })
      this.afterAddSocketDetails(item)
    },
    // ==========================================================================================
    // EVENTOS PARA MANIPULAÇÃO DOS DETALHES
    // Evento emitido quando o usuário adiciona detalhes a algum item.
    addSocketDetails (item) {
      // utilizado somente para
      if (this.beforeAddSocketDetails(item) !== false) {
        if (item.values.shift) {
          this.editedItem[item.details].unshift(item.values.comment)
          this.editedItemDB[item.details].unshift(item.values.comment)
        } else {
          this.editedItem[item.details].push(item.values)
          this.editedItemDB[item.details].push(item.values)
          this.afterAddSocketDetails(item)
        }
      }
    },
    // Evento emitido quando o usuário edita detalhes de algum item.
    editSocketDetails (item) {
      Object.assign(this.editedItem[item.details].find(
        (val) => { return val.id === item.values.id }) || {}, item.values)
      Object.assign(this.editedItemDB[item.details].find(
        (val) => { return val.id === item.values.id }) || {}, item.values)
    },
    editSocketDetailsMany (item) {
      var compare = item.values.compare ? item.values.compare : 'user_id'
      var ids = item.values.ids
      delete item.values.ids
      delete item.values.compare
      ids.forEach(id => {
        Object.assign(this.editedItem[item.details].find(
          (val) => { return val[compare] === id }) || {}, item.values)
        Object.assign(this.editedItemDB[item.details].find(
          (val) => { return val[compare] === id }) || {}, item.values)
      })
    },
    // Evento emitido quando o usuário exclui detalhes de algum item.
    deleteSocketDetails (item) {
      if (this.beforeDeleteSocketDetails(item) !== false) {
        const index = this.editedItem[item.details].findIndex(
          (element) => { return element.id === item.values.id })
        this.editedItem[item.details].splice(index, 1)
        this.editedItemDB[item.details].splice(index, 1)
        this.afterDeleteSocketDetails(item)
      }
    },
    // ==========================================================================================
    // EVENTO UTILIZADO PARA CHAMADA DE UMA SNACKBAR PARA MENSAGENS AO USUARIO
    socketSnackbar (item) {
      if (this.beforeSocketSnackbar(item) !== false) {
        this.$store.commit('snackbar/change_values', {
          text: item.text,
          color: (item.color ? item.color : 'warning'),
          dialog: true,
          timeout: (item.timeout ? item.timeout : 5000)
        })
      }
      this.afterSocketSnackbar(item)
    },
    // ==========================================================================================
    // EVENTOS PARA MANIPULAÇÃO DE VALORES NA TELA DE GERENCIAMENTO
    editSocketManagementDetails (item) {
      this.$store.commit('snackbar/change_values', {
        text: `Houve alterações nesta ${item.entity}, poderá haver conflitos. Verifique as mudanças.`,
        color: 'warning',
        dialog: true,
        timeout: 20000
      })
      Object.assign(this.editedItem, JSON.parse(JSON.stringify(item.values)))
      Object.assign(this.editedItemDB, JSON.parse(JSON.stringify(item.values)))
      this.afterEditSocketManagementDetails(item)
    },
    // Este evento funciona da seguinte maneira: é disparado quando o usuário é removido de uma empresa, quando uma empresa que ele participa é excluída ou quando o privilégio de administrador de uma empresa é retirado deste usuário.
    // Ele é responsável por mostrar na tela o alerta para informar o usuário em uma das duas situações:
    // 1 - Ele está gerenciando/editando a empresa da qual ele foi removido
    // 2 - A empresa que ele está gerenciando/editando foi excluída do sistema.
    deleteSocketDetailUser (item) {
      // Verifica se o usuário que recebeu o evento é o participante excluído (ou se ele é participante da empresa (no caso 2))
      if (item.company_id && item.company_id !== this.$auth.user().company_id) {
        return
      }
      if (item.user_id === this.$auth.user().id) {
        if (item.unlockRoom) {
          this.$socket.emit('leaveRoom',
            {room: item.unlockRoom, view: this.view})
        }
        this.$store.commit('dialogWarning/change_values',
          {text: item.text, showDialog: true})
      }
    },
    // ==========================================================================================
    // EVENTOS PARA MANIPULAÇÃO DE DETALHES NA TELA DE CONSULTA PRINCIPAL
    addSocketItemDetails (item) {
      if (this.beforeAddSocketItemDetails(item) !== false) {
        // Encontra a equipe
        let team = this.items.find(
          (val) => { return val.id === item.values.team_id })
        // Se encontrar a equipe, adiciona o novo participantes
        if (team) {
          team[item.details].push(item.values)
        }
        // Altera também no allItems para adicionar o item mesmo se estiver filtrado.
        let allItem = this.allItems.find(
          (val) => { return val.id === item.values.team_id })
        if (allItem) {
          allItem[item.details].push(JSON.parse(JSON.stringify(item.values)))
        }
      }
    },
    editSocketItemDetails (item) {
      if (this.beforeEditSocketItemDetails(item) !== false) {
        // Encontra a equipe e entra nos usuários dela.
        let team = this.items.find(
          (val) => { return val.id === item.values.team_id })
        let allItem = this.allItems.find(
          (val) => { return val.id === item.values.team_id })

        if (team) {
          // Na equipe, encontra o participante editado e atribui os novos valores a ele.
          Object.assign(team[item.details].find(
            (val) => { return val.id === item.values.id }) || {}, item.values)
        }
        if (allItem) {
          // Altera também no allItems para adicionar o item mesmo se estiver filtrado.
          Object.assign(allItem[item.details].find(
            (val) => { return val.id === item.values.id }) || {},
            JSON.parse(JSON.stringify(item.values)))
        }
      }
    },
    deleteSocketItemDetails (item) {
      if (this.beforeDeleteSocketItemDetails(item) !== false) {
        // Encontra a equipe e entra nos usuários dela.
        let team = this.items.find(
          (val) => { return val.id === item.values.team_id })
        let allItem = this.allItems.find(
          (val) => { return val.id === item.values.team_id })
        if (team) {
          // Na equipe, encontra o item a ser excluído e o exclui da lista de participantes daquela equipe
          const teamIndex = team[item.details].findIndex(
            (element) => { return element.id === item.values.id })
          team[item.details].splice(teamIndex, 1)
        }
        if (allItem) {
          // Altera também no allItems para adicionar o item mesmo se estiver filtrado.
          const allItemIndex = allItem[item.details].findIndex(
            (element) => { return element.id === item.values.id })
          allItem[item.details].splice(allItemIndex, 1)
        }
      }
    },
    // ==========================================================================================
    // EVENTO CRIADO EXCLUSIVAMENTE PARA ACEITAR CONEXÕES
    // ESSE EVENTO É UTILIZADO SOMENTE NA TELA DE CONEXÃO
    // Evento emitido quando o usuário aceita um convite de conexão.
    acceptConnection (item) {
      Object.assign(this.items.find(
        (val) => { return val.id === item.connection_id }) || {},
        JSON.parse(JSON.stringify(item)))
      Object.assign(this.allItems.find(
        (val) => { return val.id === item.connection_id }) || {},
        JSON.parse(JSON.stringify(item)))
    },
    // * Evento que recebe uma resposta do evento "checkRoomEmpty" do servidor, que verifica se a sala de edição está vazia.
    editRoomNotEmpty (item) {
      // ! IMPORTANTE -> State igual a true significa que a sala de edição está ocupada, então devemos mostrar o dialog de aviso.
      if (item.user_id === this.$auth.user().id) {
        if (item.state) {
          this.confirmEditDialog = !this.confirmEditDialog // * Mostra o dialog de aviso na tela.
        } else {
          this.confirmEdit()
        }
      }
    },
    // Evento geral para resolução de problemas específicos das telas. (em cada tela este evento será utilizado de uma maneira através do "methodGeneralSocket()")
    generalSocket (item) {
      this.methodGeneralSocket(item)
    },
    reloadPageModules (item) {
      if (this.beforeReloadPageModules(item) !== false) {
        this.$store.commit('dialogWarning/change_values',
          {text: item.text, showDialog: true})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/socketTasktemplate.js